import { render, staticRenderFns } from "./externalLink.vue?vue&type=template&id=87722ed0&scoped=true"
import script from "./externalLink.vue?vue&type=script&lang=js"
export * from "./externalLink.vue?vue&type=script&lang=js"
import style0 from "./externalLink.vue?vue&type=style&index=0&id=87722ed0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87722ed0",
  null
  
)

export default component.exports